module.exports = __webpack_public_path__ + "img/step3.24b55eeb.png";